import React from 'react'

import { ESIGNATURE_PDF_SECTION_STYLES } from '@/components/misc/ReferralESignatureConsentPdf/constants'
import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement>

const PdfSection: React.FC<Props> = ({ style, className, ...props }) => (
  <div
    {...props}
    className={cn('mb-4', className)}
    style={{ ...ESIGNATURE_PDF_SECTION_STYLES, ...style }}
  />
)

export default PdfSection
